import { render, staticRenderFns } from "./AdminDashRevenueGraph.vue?vue&type=template&id=1dca656c&scoped=true"
import script from "./AdminDashRevenueGraph.vue?vue&type=script&lang=js"
export * from "./AdminDashRevenueGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca656c",
  null
  
)

export default component.exports